import {
  CellApiModule,
  CellSelectionModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ClipboardModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  CsvExportModule,
  DateFilterModule,
  ExcelExportModule,
  GridStateModule,
  LicenseManager,
  LocaleModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  PinnedRowModule,
  PivotModule,
  RichSelectModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  RowSelectionModule,
  RowStyleModule,
  SetFilterModule,
  SideBarModule,
  StatusBarModule,
  TextEditorModule,
  TextFilterModule,
  ValidationModule,
} from 'ag-grid-enterprise';

// Register all modules we're using:
// https://www.ag-grid.com/react-data-grid/modules/
// IMPORTANT: If you've added a new piece of functionality to our grid but it isn't working,
// check to make sure we're not missing the module that enables it here.
ModuleRegistry.registerModules([
  CellApiModule,
  CellSelectionModule,
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ClipboardModule,
  ColumnApiModule,
  ColumnAutoSizeModule,
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  CsvExportModule,
  DateFilterModule,
  ExcelExportModule,
  GridStateModule,
  LocaleModule,
  NumberEditorModule,
  NumberFilterModule,
  PinnedRowModule,
  PivotModule,
  RichSelectModule,
  RowApiModule,
  RowAutoHeightModule,
  RowDragModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  RowSelectionModule,
  RowStyleModule,
  SetFilterModule,
  SideBarModule,
  StatusBarModule,
  TextEditorModule,
  TextFilterModule,
  ValidationModule,
]);

// Install our license key:
// https://www.ag-grid.com/react-data-grid/license-install/
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-117349}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Join_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Join_App}_only_for_{6}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Join_App}_need_to_be_licensed___{Join_App}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_March_2027}____[v3]_[01]_MTgwNjQ0NzYwMDAwMA==59420bef7d6e82554d3a6126a51a5e82'
);
